import { useState, useCallback } from 'react';

/**
 * Hook personalizado para manejar la lógica de búsqueda y filtrado.
 * @param {string} initialSearchTerm - El término de búsqueda inicial.
 * @param {string} initialFilterStatus - El estado de filtro inicial.
 * @param {string} initialSearchType - El tipo de búsqueda inicial ('device' o 'contact').
 * @returns {object} - Estado y manejadores para la búsqueda.
 */
export const useSearchAndFilter = (initialSearchTerm = '', initialFilterStatus = 'all', initialSearchType = 'device') => {
  const [searchInput, setSearchInput] = useState(initialSearchTerm);
  const [searchTerm, setSearchTerm] = useState(initialSearchTerm);
  const [filterStatus, setFilterStatus] = useState(initialFilterStatus);
  const [searchType, setSearchType] = useState(initialSearchType);

  const handleSearchInputChange = useCallback((value) => {
    setSearchInput(value);
  }, []);

  const handleSearch = useCallback(() => {
    setSearchTerm(searchInput);
  }, [searchInput]);

  const handleClear = useCallback(() => {
    setSearchInput('');
    setSearchTerm('');
  }, []);

  const handleKeyPress = useCallback((event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  }, [handleSearch]);

  const handleFilterChange = useCallback((eventOrValue) => {
    // Manejar tanto eventos como valores directos
    const value = eventOrValue?.target?.value ?? eventOrValue;
    setFilterStatus(value);
  }, []);

  const handleSearchTypeChange = useCallback((newSearchType) => {
    setSearchType(newSearchType);
    // Limpiar búsqueda cuando cambie el tipo
    setSearchInput('');
    setSearchTerm('');
  }, []);

  return {
    searchInput,
    setSearchInput,
    searchTerm,
    setSearchTerm,
    filterStatus,
    setFilterStatus,
    searchType,
    setSearchType,
    handleSearchInputChange,
    handleSearch,
    handleClear,
    handleKeyPress,
    handleFilterChange,
    handleSearchTypeChange,
  };
};

export default useSearchAndFilter; 